// src/pages/User/NewRequest/usecases/products/repriceCartItem.ts

import type { NewRequestServices } from "../../../model/services.model";
import { CartItem } from "../../../model/product.cart.model";

import { subtotalApplyTaxAccordingFreight } from "../../../domain/calculations/subtotalApplyTaxAccordingFreight";
import { FreightType } from "../../../model/customer.model";

export async function repriceCartItem(args: {
  services: NewRequestServices;
  freightType: FreightType;

  currentCart: CartItem[];
  targetId: string;

  patch: Partial<Pick<CartItem, "quantity" | "payment" | "deadlinePayment">>;
}): Promise<CartItem[]> {
  const target = args.currentCart.find((c) => c.id === args.targetId);
  if (!target) throw new Error("Item não encontrado no carrinho.");

  const nextDeadline =
    args.patch.deadlinePayment ?? target.deadlinePayment ?? 0;

  const nextPayment =
    args.patch.payment ?? target.payment ?? (nextDeadline > 0 ? "B" : "T");

  const nextQuantity = Math.max(
    0,
    Math.floor(Number(args.patch.quantity ?? target.quantity))
  );

  const priced = await args.services.productService.execute({
    addressID: target.addressId,
    deadlinePayment: nextDeadline,
    productID: target.productId,
    customerID: target.customerId,
    filialID: target.filialId,
    transportationZone: target.transportationZone,
  });

  const subtotal = subtotalApplyTaxAccordingFreight(
    nextQuantity,
    args.freightType,
    priced.price,
    priced.freight
  );

  const total = subtotal;

  const updated: CartItem = {
    ...target,
    payment: nextPayment,
    deadlinePayment: nextDeadline,
    quantity: nextQuantity,

    unitPrice: priced.price,
    freightUnitPrice: priced.freight,
    payCondMax: Number(priced.payCond),

    subtotal,
    total,
  };

  return args.currentCart.map((it) => (it.id === updated.id ? updated : it));
}
